import * as React from "react";
import { Icon } from "@grandvisionhq/icons";
import { useIntl } from "@grandvisionhq/state";
import { Util } from "@grandvisionhq/stores-v2";
/* empty css                     */
const StoreSuggestion = ({
  suggestion,
  targetPath,
  isMultilingualEnabled,
  onClick
}) => {
  const { locale } = useIntl();
  const getLocalizedValue = (storeField, fallBackValue) => isMultilingualEnabled && storeField && storeField[locale] ? storeField[locale] : fallBackValue;
  const selectedStore = getLocalizedValue(suggestion.storeNameLocalized, suggestion.storeName);
  const storeDetailsUrl = Util.getStoreDetailUrl(targetPath)(suggestion);
  return /* @__PURE__ */ React.createElement("div", { className: "store-suggestion__item" }, /* @__PURE__ */ React.createElement(
    "a",
    {
      "data-t": "SuggestionLink",
      className: "store-suggestion__link",
      href: storeDetailsUrl,
      onClick: () => onClick && onClick(suggestion.objectID, suggestion.position)
    },
    /* @__PURE__ */ React.createElement("span", { className: "store-suggestion__icon-wrapper" }, /* @__PURE__ */ React.createElement(Icon, { name: "store", className: "store-suggestion__store-icon" })),
    /* @__PURE__ */ React.createElement("span", { className: "store-suggestion__title store-suggestion--wrap-text" }, selectedStore),
    /* @__PURE__ */ React.createElement("span", { className: "store-suggestion__subtitle store-suggestion--wrap-text" }, `${getLocalizedValue(suggestion.townLocalized, suggestion.town)},  ${getLocalizedValue(
      suggestion.streetNameLocalized,
      suggestion.streetName
    )} ${suggestion.streetNumber || ""} `)
  ));
};
export {
  StoreSuggestion,
  StoreSuggestion as default
};
//# sourceMappingURL=StoreSuggestion.js.map
